// utils
import forceInt from "../../../../utils/ForceInt";

/**
 * This converts an hour and meridiem to a 24-hour time.
 * @param {number} hour - an hour
 * @param {string} meridiem - a meridiem (am, pm)
 */
export const convertFullTimeToHour = (hour, meridiem) => {
	let fullHour = hour;

	if (meridiem === "pm") {
		fullHour += 12;
	}

	if (hour === 12) {
		fullHour -= 12;
	}

	return fullHour;
};

/**
 * Convert an hour to an object with hour and meridiem.
 */
export const parseTimeAs12Hour = (time) => {
	let hour = forceInt(time);
	let meridiem = "am";

	if (hour === 0) {
		hour = 12;
		meridiem = "am";
	} else if (hour === 12) {
		meridiem = "pm";
	} else if (hour > 12) {
		hour -= 12;
		meridiem = "pm";
	}

	return {
		hour,
		meridiem,
	};
};

export const parseTime = (time) => {
	const hour = forceInt(time);
	// let meridiem = 'am';

	// if (hour === 0) {
	//     hour = 12;
	//     meridiem = 'am';
	// }
	// else if (hour === 12) {
	//     meridiem = 'pm';
	// }
	// else if (hour > 12) {
	//     hour -= 12;
	//     meridiem = 'pm';
	// }

	return {
		hour,
		// meridiem,
	};
};

export function areDeferredTimesEqual(cachedDeferredTime, currentDeferredTime) {
	let isEqual = cachedDeferredTime.length === currentDeferredTime.length && cachedDeferredTime.length !== 0;

	if (isEqual) {
		cachedDeferredTime.forEach((time, index) => {
			if (time.hour !== currentDeferredTime[index].hour) {
				isEqual = false;
			}
		});
	}

	return isEqual;
}

export const areWeeklyDigestsEqual = (cachedWeeklyDigest, currentWeeklyDigest) =>
	cachedWeeklyDigest.day === currentWeeklyDigest.day && cachedWeeklyDigest.hour === currentWeeklyDigest.hour;
